// This file is autogenerated. Any changes will be overwritten.

export const set = 'streamline';

export const name = 'dock';

export const Component = () => (
  <path
    stroke='currentColor'
    strokeLinecap='round'
    d='m10.5 7.5 5.75-5.75m-5.75 1V7.5m4.75 0H10.5m-3 3-5.75 5.75m5.75-1V10.5m-4.75 0H7.5'
  />
);

export const viewBox = '0 0 18 18';
